import InfiniteScrollHistoryView from './InfiniteScrollHistoryView';
export default InfiniteScrollHistoryView;
